type LiveReportProps = {
  reports: string[];
};

export function LiveReport({ reports }: LiveReportProps) {
  return (
    <section className="live-report" aria-label="ライブレポート">
      <div className="report-label">
        <span className="pulse-dot" />
        <strong>LIVE REPORT</strong>
      </div>
      <div className="report-copy">
        {reports.map((report) => (
          <p key={report}>{report}</p>
        ))}
      </div>
    </section>
  );
}
